import FarolListItemEditor from './FarolListItemEditor'
import EditHintIcon        from '../Cards/EditHintIcon'

const FarolList = ({

    farols,
    hasPermission,

    editingFarolId,
    isAddingFarol,
    options,

    handleStartEdit,
    handleSave,
    handleCancel,
    handleDelete

}) => {

    const renderEditor = (farol) => (

        <FarolListItemEditor
            key={farol ? farol.id : 'novo'}
            farol={farol}
            options={options}
            onSave={(farolData) => handleSave(farol?.id ?? null, farolData)}
            onCancel={() => handleCancel(farol?.id ?? null)}
            onDelete={() => handleDelete(farol.id)}
        />
    )

    return (

        <section className="min-h-[101px] flex-grow">

            {/* Em edição a lista perde o limite de altura/rolagem, senão os menus dos selects ficam cortados. */}
            <ul
                className={`block relative text-[0.9rem] !border-[#dfdfdf] ${editingFarolId || isAddingFarol ? '!max-h-none !overflow-visible' : ''}`}
                style={{ position: "revert" }}
            >

                {farols.length > 0 || isAddingFarol ? (

                    farols.map((farol) => {

                        if (farol.id === editingFarolId) return renderEditor(farol)

                        const { ownerFarolRestriction, ownerProduct, ownerHooper, ownerCategory, description } = farol;

                        return (

                            <li
                                key={farol.id}
                                // Sem permissão: sem fundo, borda ou cursor no hover (a classe item-farol traz esses efeitos).
                                className={hasPermission ? 'item-farol group flex items-start gap-1 border border-dashed border-transparent hover:border-gray-300 cursor-text' : 'rounded-[5px]'}
                                title={hasPermission ? 'Clique duas vezes para editar' : undefined}
                                onDoubleClick={hasPermission ? () => handleStartEdit(farol.id) : undefined}
                            >
                                <span className="flex-grow">
                                    {
                                        ownerFarolRestriction?.name === "Sem Restrição"    ? "🟢" :
                                        ownerFarolRestriction?.name === "Ponto de Atenção" ? "🟡" : "🔴"
                                    }

                                    <strong>
                                        {ownerProduct?.name}
                                        {ownerHooper ? ` (${ownerHooper.name})` : ""}:
                                    </strong>

                                    {ownerCategory?.name ? `${ownerCategory.name}, ` : ""}
                                    {description || ""}
                                </span>

                                {hasPermission && <EditHintIcon className="mt-[3px]" />}
                            </li>
                        );
                    })
                ) : (
                    <p>Sem Itens</p>
                )}

                {isAddingFarol && renderEditor(null)}

            </ul>

        </section>
    );
};

export default FarolList;
